export default "__VITE_ASSET__CHiU2ErM__"